export default __webpack_public_path__ + "static/media/foodworks_horizontal.3d61e92e.png";